import { getApiErrorMessage } from '@/shared/api';
import { extendSession, login, logout } from './api';
import { LoginRequest } from './types';

export * from './api';
export * from './types';

/**
 * Authentication API service
 */
export const authService = {
  /**
   * Login with email and password
   * @param credentials - Login credentials (email and password)
   */
  async login(credentials: LoginRequest): Promise<void> {
    try {
      await login(credentials);
    } catch (error) {
      // Причина отказа — текст ответа: неверный пароль, временная блокировка входа, истёкший временный пароль
      throw new Error(getApiErrorMessage(error));
    }
  },

  /**
   * Продлевает текущую сессию: работа продолжается без повторного входа.
   * Отказ пробрасывается вызывающему — отсчёт до конца сессии продолжается.
   */
  async extendSession(): Promise<void> {
    await extendSession();
  },

  /**
   * Logout current user.
   */
  async logout(): Promise<void> {
    try {
      await logout();
    } catch {
      // Best-effort: server notification failed
    }
  },
};
